import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getImgUrl,
  getPage,
  getParamValue,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import AddCorporate from "./AddCorporate";
import { responseNotification } from "../../utils/notify";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import usePrevious from "../../hooks/PreviousState";

const CorporateList = () => {
  const router = useLocation();
  const history = useHistory();
  const [confirmLoading, setConfirmLoading] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [corporateOptions, setCorporateOptions] = useState({
    loading: false,
    list: [],
  });
  const [key, setKey] = useState(getParamValue(router.search, "key"));
  const [selectedCorporate, setSelectedCorporate] = useState(undefined);
  const [selectedCorporateForEdit, setSelectedCorporateForEdit] =
    useState(undefined);
  const [status, setStatus] = useState("");
  // const [type, setType] = useState(
  //   getParamValue(router.search, "key") || "JC_MART"
  // );
  const [limit, setLimit] = useState(16);
  const [corporateData, setCorporateData] = useState({
    loading: false,
    data: null,
  });

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  // const previousType = usePrevious(type);
  const previousKey = usePrevious(key);

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberCorporateList")
    );
    console.log("rememberCorporateList: ", retrievedObject);

    if (retrievedObject.mobileNumber) setKey(retrievedObject.key);
    // if (retrievedObject.type) setType(retrievedObject.type);
  }

  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberCorporateList",
      JSON.stringify({
        key: key,
        // type: type,
        page: page,
      })
    );
  };

  const getCorporate = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberCorporateList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberCorporateList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey],
        [key],
        ["key"],
        history
      );
    }
    setCorporateData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/company/all?page=${pageReseted ? 0 : page || 0}&limit=${
          limit || 16
        }` + (key ? `&name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setCorporateData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setCorporateData({ loading: false, data: [] });
        console.error("Corporate: Error", err);
      });
  }, [page, limit, key]);

  useEffect(() => {
    getCorporate();
  }, [getCorporate]);

  const getCorporateOptions = useCallback(async (key) => {
    setCorporateOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    return axios
      .get(
        `${encodedUri}/company/all?page=0&limit=20` +
          (key ? `&name=${key}` : ``) +
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
      )
      .then((res) => {
        setCorporateOptions({
          loading: false,
          list: res.data?.companies?.map((company) => ({
            label: company.name,
            value: company.name,
          })),
        });
      })
      .catch((err) => {
        setCorporateOptions({ loading: false, list: [] });
        console.error("Hubs: Error", err);
      });
  }, []);

  //
  const onStatusChange = async (id, val: any) => {
    setConfirmLoading(id);
    if (id) {
      await fetch(`${process.env.REACT_APP_RIDER_API}/company`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setConfirmLoading(undefined);
          if (res.statusCode === 200) {
            responseNotification("Status Changed Successfully", "success");
            getCorporate();
            setVisible(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    form.resetFields();
    history.replace(router.pathname);
    window.location.reload();
  };

  useEffect(() => {
    if (visible) {
      setSelectedCorporate(undefined);
      setSelectedCorporateForEdit(undefined);
    }
  }, [selectedCorporate, selectedCorporateForEdit, visible]);

  useEffect(() => {
    setSelectedCorporate(undefined);
    setSelectedCorporateForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedCorporate(null);
    setSelectedCorporateForEdit(null);
    getCorporate();
  };

  const fetchRef = useRef(0);
  const debouncecorporateOptionsFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getCorporateOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getCorporateOptions]);

  return (
    <React.Fragment>
      <TopHeading
        total={corporateData?.data?.totalElements}
        refetch={getCorporate}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search" initialValue={key}>
            <AutoComplete
              style={{ width: 300 }}
              onSearch={debouncecorporateOptionsFetcher}
              onSelect={(val) => setKey(val.toString())}
              options={corporateOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                corporateOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={corporateOptions.loading}
              />
            </AutoComplete>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Company Name</span>
                  </div>

                  <div className="single-product-heading">
                    <span>Created Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Balance</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {corporateData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {corporateData?.data?.companies?.length ? (
                    corporateData?.data?.companies?.map(
                      (company: any, index: any) => (
                        <React.Fragment key={index}>
                          <Link
                            to={`/corporates/${company?.id}/details`}
                            onClick={saveCurrentStatesInLocalStorage}
                          >
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <Avatar
                                  shape="circle"
                                  size={45}
                                  src={getImgUrl(company?.image)}
                                  className="mr-3"
                                />
                                <span className="name">
                                  {company?.name?.toUpperCase()}
                                </span>
                              </div>
                              {/* <div className="single-product">
                                <span className="name">
                                  {company?.type?.replace("_", " ")}
                                </span>
                              </div> */}
                              <div className="single-product">
                                <span className="name">
                                  {moment(company?.createdAt).format("lll")}
                                </span>
                              </div>

                              <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={company?.isActive}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    onStatusChange(company?.id, val);
                                  }}
                                  loading={
                                    confirmLoading &&
                                    company?.id === confirmLoading
                                  }
                                />
                              </div>

                              <div className="single-product">
                                <span className="name">{company?.balance}</span>
                              </div>
                              <div className="single-product">
                                <Link
                                  to=""
                                  className="btn btn-sm btn-warning mx-1"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedCorporateForEdit(company?.id);
                                  }}
                                >
                                  <EditOutlined />
                                </Link>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Companies" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={"Edit Company"}
            width={600}
            onClose={() => {
              setSelectedCorporate(null);
              setSelectedCorporateForEdit(null);
            }}
            visible={selectedCorporate || selectedCorporateForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedCorporateForEdit ? (
              <AddCorporate
                onCloseMethod={onClose}
                visibleData={selectedCorporateForEdit}
              />
            ) : undefined}
          </Drawer>

          <PaginationTwo
            {...corporateData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CorporateList;
